import React from 'react';
import styles from '../../styles/bio/bio_desc.scss';


export const BioDescription = props => {
    return (
        <div className={styles.container} onClick={props.onClick}>
            <span className={styles.descriptionText}>{props.text}</span>
            {
                props.bullets ?
                <ul>
                    {props.bullets?.map((bullet) => {
                        return <li key={bullet}>{bullet}</li>
                    })}
                </ul>
                : undefined
            }
            <div className={styles.techContainer}>
                {props.iconComponentList?.map((value) => {
                    return value;
                })}
            </div>
        </div>
    )
};
